import storage from 'localforage';
export default storage;